import { useContext } from 'react';

import ToggleThemeContext from './context';

const useToggleTheme = (): VoidFunction => useContext(ToggleThemeContext);

export default useToggleTheme;
